import { render, staticRenderFns } from "./OTPForm.vue?vue&type=template&id=60993093&scoped=true&"
import script from "./OTPForm.vue?vue&type=script&lang=ts&"
export * from "./OTPForm.vue?vue&type=script&lang=ts&"
import style0 from "./OTPForm.vue?vue&type=style&index=0&id=60993093&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60993093",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60993093')) {
      api.createRecord('60993093', component.options)
    } else {
      api.reload('60993093', component.options)
    }
    module.hot.accept("./OTPForm.vue?vue&type=template&id=60993093&scoped=true&", function () {
      api.rerender('60993093', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/components/OTPForm.vue"
export default component.exports